/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Alerts(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 25 25'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>alerts</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#000'}
                        id='Layer_1-2'
                    >
                        <path d='M23.62,19.24H21.71V8.66C21.71,4.45,17,0,12.5,0S3.29,4.45,3.29,8.66V19.24H1.38a1.38,1.38,0,0,0,0,2.76H9.05a4.12,4.12,0,0,0,3.81,3,4.1,4.1,0,0,0,3.8-3h7a1.38,1.38,0,0,0,0-2.76ZM12.86,24a3.2,3.2,0,0,1-2.79-2h5.58A3.23,3.23,0,0,1,12.86,24Zm10.76-3H1.38a.38.38,0,1,1,0-.76H4.29V8.66C4.29,5,8.59,1,12.5,1s8.21,4,8.21,7.66V20.24h2.91a.38.38,0,0,1,0,.76Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}